module.exports = __webpack_public_path__ + "img/zhangjiagangLOGO.50763196.png";